// import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import CategoryApi from '../apiProvider/categoryapi';
import subCategoryApi from '../apiProvider/subcategoryapi';
import { IMAGE_BASE_URL } from '../network/apiClient';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const AddSubCategoryPage = () => {
  const [categories, setCategories] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get("from");

  const navigate = useNavigate();
  const location = useLocation();
  const { editDatas } = location.state || {};

  const [formData, setFormData] = useState({
    subCategoryName: '',
    parentCategory: '',
    description: '',
    Image: '',
    slug: '',
    tags: '',
    featuredCategory: true,
    title: '',
    metaKeywords: '',
    metaDescription: '',
    status: true,
    displayOrder: '',
    origins: false,
    variants: false,
    others: false,
  });

  /* -----------------------------
        CHANGE HANDLER
  ----------------------------- */
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    setFormData({
      ...formData,
      [name]: type === 'file' ? files[0] : type === 'checkbox' ? e.target.checked : value
    });
  };

  const handleFeatureFlagChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      origins: name === "origins" ? checked : false,
      variants: name === "variants" ? checked : false,
      others: name === "others" ? checked : false,
    }));
  };

  /* -----------------------------
        VALIDATION
  ----------------------------- */
  const Validate = () => {
    let newErrors = {};

    if (!formData.subCategoryName.trim()) {
      newErrors.subCategoryName = "Sub category name is required";
    }

    if (!isEditMode && !formData.Image) {
      newErrors.Image = "Image is required";
    }

    if (isEditMode && !formData.Image && !formData.image) {
      newErrors.Image = "Image is required";
    }

    if (!formData.parentCategory) {
      newErrors.parentCategory = "Parent category is required";
    }
    
    if (!formData.origins && !formData.variants && !formData.others) {
      newErrors.featureFlags = "At least one of Origins, Variants, or Others must be selected";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* -----------------------------
        SUBMIT HANDLER
  ----------------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!Validate()) return;

    const form = new FormData();
    form.append("image", formData.Image);
    form.append("category", formData.parentCategory);
    form.append("name", formData.subCategoryName);
    form.append("description", formData.description);

    form.append("slug", formData.slug);

    form.append("tags", formData.tags);
    form.append("featuredCategory", formData.featuredCategory);
    form.append("metaTitle", formData.title);
    form.append("metaKeywords", formData.metaKeywords);
    form.append("metaDescription", formData.metaDescription);
    form.append("displayOrder", formData.displayOrder);
    form.append("status", formData.status);
    form.append("isActive", formData.status);
    form.append("origins", formData.origins);
    form.append("variants", formData.variants);
    form.append("others", formData.others);

    if (isEditMode) {
      form.append("id", formData.id);
    }

    try {
      let response;

      if (isEditMode) {
        response = await subCategoryApi.updateSubCategory(formData.id, form);
      } else {
        response = await subCategoryApi.addSubCategory(form);
      }

      if (response.status) {
        toast(response.message);

        setTimeout(() => {
          if (returnTo === "subcategorylist") {
            navigate("/category?type=subcategorylist");
          } else if (returnTo === "childcategorylist") {
            navigate("/category?type=childcategorylist");
          } else {
            navigate("/category");
          }
        }, 800);
      } else {
        toast(response.message);
      }
    } catch (err) {
      console.error("Error saving:", err);
    }
  };

  /* -----------------------------
        FETCH CATEGORIES
  ----------------------------- */
  const fetchGetCategories = async () => {
    try {
      const categoryResult = await CategoryApi.getCategory({ status: true });
      setCategories(categoryResult.data.data.items || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchGetCategories();
  }, []);

  /* -----------------------------
        AUTO SLUG GENERATION
  ----------------------------- */
  useEffect(() => {
    const slug = formData.subCategoryName
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9\-]/g, "")
      .replace(/\-+/g, "-")
      .replace(/^-+|-+$/g, "");

    setFormData((prev) => ({ ...prev, slug }));
  }, [formData.subCategoryName]);

  /* -----------------------------
        EDIT MODE DATA FILL
  ----------------------------- */
  useEffect(() => {
    if (!editDatas) return;

    setIsEditMode(true);

    setFormData({
      id: editDatas._id,
      subCategoryName: editDatas.name || "",
      parentCategory: editDatas.category?._id || "",
      description: editDatas.description || "",
      Image: "",
      slug: editDatas.slug || "",
      tags: editDatas.tags || "",
      featuredCategory: !!editDatas.featuredCategory,
      title: editDatas.metaTitle || "",
      metaKeywords: editDatas.metaKeywords || "",
      metaDescription: editDatas.metaDescription || "",
      status: editDatas.status ? "true" : "false",
      displayOrder: editDatas.displayOrder || "",
      origins: !!editDatas.origins,
      variants: !!editDatas.variants,
      others: !!editDatas.others,
      image: editDatas.images?.length > 0 ? editDatas.images[0] : null,
    });
  }, [editDatas]);

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-end">
        <div className="col-md-12">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row gy-3">

                {/* CATEGORY */}
                <div className='col-sm-6'>
                  <label className='form-label'>Category <span className="text-danger">*</span></label>
                  <select
                    className='form-select radius-8'
                    name="parentCategory"
                    value={formData.parentCategory}
                    onChange={handleChange}
                  >
                    <option value="">--Select Category--</option>
                    {categories.map((c) => (
                      <option key={c._id} value={c._id}>{c.name}</option>
                    ))}
                  </select>
                  {errors.parentCategory && <div className="text-danger">{errors.parentCategory}</div>}
                </div>

                {/* SUBCATEGORY NAME */}
                <div className='col-sm-6'>
                  <label className='form-label'>Sub Category Name <span className="text-danger">*</span></label>
                  <input
                    type='text'
                    className='form-control radius-8'
                    name="subCategoryName"
                    value={formData.subCategoryName}
                    onChange={handleChange}
                  />
                  {errors.subCategoryName && <div className="text-danger">{errors.subCategoryName}</div>}
                </div>

                {/* DESCRIPTION */}
                <div className='col-sm-6'>
                  <label className='form-label'>Description</label>
                  <input
                    type='text'
                    className='form-control radius-8'
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                {/* IMAGE */}
                <div className='col-sm-6'>
                  <label className='form-label'>Sub Category Image <span className="text-danger">*</span></label>
                  <input
                    className='form-control radius-8'
                    type="file"
                    name="Image"
                    accept="image/png, image/jpeg"
                    onChange={handleChange}
                  />

                  {isEditMode && formData.image && (
                    <img
                      src={`${IMAGE_BASE_URL}/${formData.image.docPath}/${formData.image.docName}`}
                      width="40"
                      height="40"
                    />
                  )}

                  {errors.Image && <div className="text-danger">{errors.Image}</div>}
                </div>

                {/* SLUG */}
                <div className='col-sm-6'>
                  <label className='form-label'>Slug</label>
                  <input
                    type='text'
                    className='form-control radius-8'
                    name="slug"
                    value={formData.slug}
                    onChange={handleChange}
                  />
                </div>

                {/* TAGS */}
                <div className='col-sm-6'>
                  <label className='form-label'>Tags</label>
                  <input
                    type='text'
                    className='form-control radius-8'
                    name="tags"
                    value={formData.tags}
                    onChange={(e) => {
                      const onlyAlpha = e.target.value.replace(/[^a-zA-Z\s,]/g, "");
                      setFormData({ ...formData, tags: onlyAlpha });
                    }}
                  />
                </div>

                {/* FEATURED */}
                <div className='col-sm-6'>
                  <label className='form-label'>Featured Category</label>
                  <select
                    className='form-select radius-8'
                    name="featuredCategory"
                    value={formData.featuredCategory}
                    onChange={handleChange}
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>

                {/* META TITLE */}
                <div className='col-sm-6'>
                  <label className='form-label'>Meta Title</label>
                  <input
                    type='text'
                    className='form-control radius-8'
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                  />
                </div>

                {/* META KEYWORDS */}
                <div className='col-sm-6'>
                  <label className='form-label'>Meta Keywords</label>
                  <input
                    type='text'
                    className='form-control radius-8'
                    name="metaKeywords"
                    value={formData.metaKeywords}
                    onChange={handleChange}
                  />
                </div>

                {/* META DESC */}
                <div className='col-sm-6'>
                  <label className='form-label'>Meta Description</label>
                  <input
                    type='text'
                    className='form-control radius-8'
                    name="metaDescription"
                    value={formData.metaDescription}
                    onChange={handleChange}
                  />
                </div>

                {/* STATUS */}
                <div className='col-sm-6'>
                  <label className='form-label'>Status</label>
                  <select
                    className='form-select radius-8'
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="">-- Select Status --</option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>

                {/* DISPLAY ORDER */}
                <div className='col-sm-6'>
                  <label className='form-label'>Display Order</label>
                  <input
                    type='number'
                    className='form-control radius-8'
                    name="displayOrder"
                    value={formData.displayOrder}
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (value >= 1 || e.target.value === "") {
                        handleChange(e);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
                    }}
                  />
                </div>

                {/* FEATURE FLAGS */}
                <div className="col-sm-6 d-flex flex-column justify-content-center pt-20">
                  <div className="d-flex align-items-center flex-wrap gap-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="origins"
                        id="origins"
                        checked={formData.origins}
                        onChange={handleFeatureFlagChange}
                      />
                      <label className="form-check-label" htmlFor="origins">
                        Origins
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="variants"
                        id="variants"
                        checked={formData.variants}
                        onChange={handleFeatureFlagChange}
                      />
                      <label className="form-check-label" htmlFor="variants">
                        Variants
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="others"
                        id="others"
                        checked={formData.others}
                        onChange={handleFeatureFlagChange}
                      />
                      <label className="form-check-label" htmlFor="others">
                        Others
                      </label>
                    </div>
                  </div>
                  {errors.featureFlags && (
                    <div className="text-danger mt-1">
                      {errors.featureFlags}
                    </div>
                  )}
                </div>

                {/* BUTTONS */}
                <div className='form-group text-end'>
                  {/* CANCEL BUTTON FIX */}
                  <button
                    type="button"
                    className='btn btn-secondary radius-8 me-2 px-32'
                    style={{ height: "45px" }}
                    onClick={() => {
                      if (returnTo === "subcategorylist") navigate("/category?type=subcategorylist");
                      else if (returnTo === "childcategorylist") navigate("/category?type=childcategorylist");
                      else navigate("/category");
                    }}
                  >
                    Cancel
                  </button>

                  {/* SAVE BUTTON */}
                  <button
                    type="submit"
                    className='btn btn-primary radius-8 px-32'
                    style={{ height: "45px" }}
                  >
                    {isEditMode ? "Update" : "Save"}
                  </button>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSubCategoryPage;
